import React from 'react'
import styled from 'styled-components'
import { ArrowBack } from 'irmlib/icons'
import { FlexByRow, XDivider, useTheme } from 'irmlib/styles'
import { Label } from 'irmlib/components/Controls'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'


const CenteringFlexRow = styled(FlexByRow)`
  align-items: center;
  cursor: pointer;
`
const PrimaryLabel = styled(Label)`
  color: ${props => props.theme.palette.primary.main};
`

const GoBackSubtitle = props => {
  const theme = useTheme()
  const history = useHistory()
  // handle back button click
  const handleClick = () => {
    if (props?.onClickBack) {
      props.onClickBack()
    } else {
      history.goBack()
    }
  }

  return (
    <CenteringFlexRow id={'backButton'} onClick={handleClick}>
      <ArrowBack />
      <XDivider width='10px' />
      <PrimaryLabel theme={theme}>{props.title || ''}</PrimaryLabel>
      <XDivider width='10px' />
    </CenteringFlexRow>
  )
}

GoBackSubtitle.propTypes = {
  title: PropTypes.string,
  onClickBack: PropTypes.func
}

export default GoBackSubtitle
